import { Tabs } from 'antd';
import styled from 'styled-components';

export const RATES = 'Rates';
export const SETTING = 'Settings';
export const MerchantDetailTabMenu = [
  {
    label: RATES,
    key: 1
  },
  {
    label: SETTING,
    key: 2
  }
];

export const MIN_AMOUNT = 'min_amount';
export const MAX_AMOUNT = 'max_amount';
export const PERCENTAGE = 'PERCENTAGE';
export const FLAT = 'FLAT';
export const BASE_RATE = 'base_rate';
export const RUPPEE_SIGN = '₹';
export const PERCENTAGE_SIGN = '%';
export const MERCHANT_COMMERCIAL = 'merchant_commercial';

export const PARTNER_COMMISSION = 'partner_commission';
export const PARTNER_IS_FLAT_RS = 'partner_is_flat_rs';

export const COMMERCIAL_TYPE = 'commercial_type';
export const COMMISSION_TYPE = 'commission_type';
export const BASE_RATE_TYPE = 'base_rate_type';

export const FLAT_FEE = 'flat_fee';

export const PRIMARY = 'primary';
export const DIFFERENTIAL = 'differential';

export const IS_ENABLE = 'is_enable';

export const DROPDOWN = 'dropdown';

const version2 = 'v2';
const version1 = 'v1';
const version3 = 'v3';

export const FIRST = 'first';

export const SWITCH = 'switch';

export { version2, version1, version3 };

export const IS_CHARGE_ON_CUSTOMER = 'is_charge_on_customer';

export const PaymentModeTabs = styled(Tabs)`
  && {
    .ant-tabs-nav-list {
      width: 200px;
    }

    .ant-tabs-tab {
      min-width: 180px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .ant-tabs-content-holder {
      padding: 0 15px;
      padding-bottom: 30px;
    }
  }
`;
export const initialValueValidator = (form, fieldPath, initialValue) => (_, value) => {
  if (value !== initialValue) {
    return form.setFields([
      {
        name: fieldPath,
        warnings: [`Initial value was ${initialValue}`]
      }
    ]);
  }
  return Promise.resolve();
};
const ACRONYMS = new Set(['UPI', 'POS', 'EMI', 'NEFT', 'RTGS', 'ENACH', 'IMPS']);

const SPECIAL_CASES = {
  NEFT_RTGS: 'NEFT / RTGS / IMPS',
  CHALLAN: 'E-Challan',
  AUTO_DEBIT_UPI: 'Auto Debit',
  CASH_CARD: 'Wallet',
  EASY_INSTALLMENT: 'Easy Installments',
  ENACH: 'E-NACH'
};
export const formatPaymentMode = (paymentModeStr) => {
  const upperStr = paymentModeStr.toUpperCase();
  if (SPECIAL_CASES[upperStr]) return SPECIAL_CASES[upperStr];

  return paymentModeStr
    .split('_')
    .map((word) => {
      const upper = word.toUpperCase();
      return ACRONYMS.has(upper)
        ? upper
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
};

export const slabType = ['primary', 'differential', 'baseRate'];
